import React, { useEffect, useRef, useState } from 'react';
import { host } from '../script/variables';

const OrderPaymentStatus = ({ orderid,changestatus,setChangeStatus }) => {
  const [status, setStatus] = useState('');
const [deliveryStatus,setDeliveryStatus] = useState('')
  const intervalRef = useRef(null);

  useEffect(() => {
    const fetchstatus = async () => {
      if (!orderid) return;
      const payload = { orderid: orderid };
  
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${host}/partner/orderstatus`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
          },
          body: JSON.stringify(payload)
        });
  
        if (response.ok) {
          const data = await response.json();
          setStatus(data.paymentStatus);
        
          
          setDeliveryStatus(data.deliveryStatus)
          if (data.paymentStatus === 'Completed' && intervalRef.current && data.deliveryStatus==='Completed' ) {
            clearInterval(intervalRef.current);
          }
        } else {
          console.log('Error in fetching order status from backend');
        }
      } catch (error) {
        console.log('Error in fetching order status from frontend');
      }
    };
  
    fetchstatus(); // Fetch initially
  
   
      intervalRef.current = setInterval(() => {
        fetchstatus();
      }, 5000); // Fetch every 5 seconds
    
  
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [orderid, status]);

 
  
  return (
    <div>
    <p>Payment Status: {status} </p> 

    

     {(status === 'Pending') ? <p className="payment-instructions">Complete the payment on counter to complete the order</p> : <p className="order-status">Delivery Status :{deliveryStatus}</p>}
     
    </div>
  );
};

export default OrderPaymentStatus;
